/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1085
 */

var r = require(/* 246 */"../../1782/246/index")
var o = require(/* 834 */"../../949/834")
var i = r("iterator")
var /* [auto-meaningful-name] */Array$prototype = Array.prototype
module.exports = function (e) {
  return undefined !== e && (o.Array === e || Array$prototype[i] === e)
}
